<template>
  <el-table :data="tableList" style="width: 100%">
    <el-table-column v-for="(item,index) in headerList" :key="index" :prop="item.prop" :label="item.name" align='center' show-overflow-tooltip :min-width="index == 0?40:''">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: ['tableData', 'headerData'],
  data() {
    return {
      tableList: [],
      headerList: [],
    };
  },
  watch: {
    tableData: {
      handler(newValue, oldValue) {
        this.tableShow(newValue, this.headerData);
      },
      deep: true,
    },
    headerData: {
      handler(newValue, oldValue) {
        this.tableShow(this.tableData, newValue);
      },
      deep: true,
    },
  },
  // beforeDestroy() {
  //   if (this.pieEcharts) {
  //     this.pieEcharts.clear()
  //   }
  // },
  mounted() {
    this.tableShow(this.tableData, this.headerData);
  },
  methods: {
    tableShow(tableData, headerData) {
      if (tableData.length > 0) {
        for (let i = 0; i < tableData.length; i++) {
          tableData[i].index = i + 1;
        }
      }
      this.tableList = tableData;
      this.headerList = headerData;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 修改表格头部背景 */
::v-deep .el-table th {
  background: rgba(31, 50, 94, 0.8);
  // border: 1px solid rgba(26 33 56) !important;
  border: 1px solid #1a2138 !important;
  border-width: 4px !important;
  border-radius: 10px;
  color: #fff;
  font-weight: 400;
}

::v-deep .el-table__cell {
  padding: 5px 0px !important;
}

/* 修改表格行背景 */
::v-deep .el-table tr {
  background: rgba(35, 42, 67, 1);
}

.el-table,
.el-table__expanded-cell {
  // background: rgb(26 33 56) !important;
  background: #1a2138 !important;
}
::v-deep .el-table::before {
  height: 0;
}

::v-deep .el-table--enable-row-hover .el-table__body tr td {
  // border: 0px solid rgb(26 33 56);
  border: 1px solid #1a2138;
  border-width: 4px;
  border-radius: 10px;
  color: #fff;
}

/* 修改表格鼠标悬浮hover背景色 */
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: transparent;
  border-width: 4px;
  border-radius: 10px;
}
</style>
